export default function studySequence(capsService, $compile) {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            capsService.getSequence(attrs.studySequence)
                .then(resp => {
                    element.html(resp.sequence);
                    $compile(element.contents())(scope);
                });
        }
    };
};
